import { render, staticRenderFns } from "./GridRow.vue?vue&type=template&id=48b8727d&scoped=true&"
import script from "./GridRow.vue?vue&type=script&lang=js&"
export * from "./GridRow.vue?vue&type=script&lang=js&"
import style0 from "./GridRow.vue?vue&type=style&index=0&id=48b8727d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8727d",
  null
  
)

export default component.exports